module.exports = __webpack_public_path__ + "static/media/instagram.6d2ab22b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact/instagram.png
// module id = 1508
// module chunks = 0